import "./font/webfont.css"
import "ol/ol.css"
import "./style.scss"
import {initMatomo} from "./matomo";

import "./map"

initMatomo()

